import React from 'react';
import PropTypes from 'prop-types';
import { media } from '../../../styles/style-utils';
import styled from 'styled-components';
import { getArtworkUrl, BLOCK_TYPE } from '../utils/Contentful';
import Hyperlink from '../../common/Hyperlink';
import { withSiteData } from 'react-static';

const Container = styled.div`
  width: calc(12 * var(--fr)) !important;
  transform: scale(1);
  transition: transform 0.3s;

  ${media.mediumLarge`
    width: calc(15 * var(--fr)) !important;
  `};

  :hover {
    transform: scale(1.05);
  }
`;

const Artwork = styled.img`
  margin-bottom: calc(var(--fr) * 0.75);
  aspect-ratio: 1 / 1;
`;

const Info = styled.div`
  flex-grow: 1;

  h3 {
    font-size: var(--fs-s);
  }
`;

const AlbumOrPlaylist = ({ content, type, appDomain }) => {
  const { title, id, image } = content;

  return (
    <Container>
      {id && (
        <Hyperlink
          to={`${appDomain}/${type === BLOCK_TYPE.PLAYLIST ? 'playlists' : 'albums'}/${id}`}
          className="dummy-btn"
          openInNewTab
          aria-label={title}
        />
      )}
      <Artwork
        src={
          getArtworkUrl(image) ||
          'https://idagio-images.global.ssl.fastly.net/sys/ph/artist-default.jpg'
        }
        alt=""
      />
      <Info>{title && <h3>{title}</h3>}</Info>
    </Container>
  );
};

AlbumOrPlaylist.propTypes = {
  content: PropTypes.object,
  type: PropTypes.string.isRequired,
  appDomain: PropTypes.string.isRequired,
};

export default withSiteData(AlbumOrPlaylist);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/audio/AlbumOrPlaylist.js